import type {
  CustomerOperationalSummary,
  DiscountReviewQueuePage,
  MandateActivationQueuePage,
  MandateOperationalSummary,
  PaymentFailureQueuePage,
  PaymentOperationalSummary,
  ProductOperationalStatsSummary,
  RepaymentAgingSummary,
} from '@solar/contracts';

import { apiClient } from '../../lib/api-client';
import { toQuery } from '../../lib/api-query';

export const operationalApi = {
  customerSummary(): Promise<CustomerOperationalSummary> {
    return apiClient.get('/admin/operational/customers/summary');
  },
  productStats(): Promise<ProductOperationalStatsSummary> {
    return apiClient.get('/admin/operational/products/stats');
  },
  repaymentAging(): Promise<RepaymentAgingSummary> {
    return apiClient.get('/admin/operational/billing/aging');
  },
  mandateSummary(): Promise<MandateOperationalSummary> {
    return apiClient.get('/admin/operational/mandates/summary');
  },
  mandateActivationQueue(page = 1, pageSize = 5): Promise<MandateActivationQueuePage> {
    return apiClient.get(
      `/admin/operational/mandates/activation-queue${toQuery({ page, pageSize })}`,
    );
  },
  paymentSummary(): Promise<PaymentOperationalSummary> {
    return apiClient.get('/admin/operational/payments/summary');
  },
  paymentFailureQueue(page = 1, pageSize = 5): Promise<PaymentFailureQueuePage> {
    return apiClient.get(`/admin/operational/payments/failure-queue${toQuery({ page, pageSize })}`);
  },
  discountReviewQueue(page = 1, pageSize = 20): Promise<DiscountReviewQueuePage> {
    return apiClient.get(
      `/admin/operational/applications/discount-review${toQuery({ page, pageSize })}`,
    );
  },
};
